<template>
  <v-dialog
      :value="!$store.state.logged"
      persistent
      max-width="400"
      overlay-opacity="0.95"
  >
    <v-form @submit.prevent="login">
      <v-card>
        <v-card-title>
          <v-icon class="mr-2">mdi-domain</v-icon>
          <span class="text-h5">Zábory a vjezdy</span>
        </v-card-title>
        <v-card-text>
          <v-text-field
              v-model="data.username"
              label="Přihlašovací jméno"
          />
          <v-text-field
              v-model="data.password"
              label="Heslo"
              type="password"
          />
          <v-alert
              v-if="error"
              color="red"
              type="warning"
          >
            {{ error }}
          </v-alert>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
              type="submit"
              color="blue darken-1"
              text
          >
            Přihlásit se
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
  </v-dialog>
</template>

<script>
import {api, defaultApiErrorHandler, loginApi} from '@/main';
import { mapGetters } from 'vuex';

export default {
  name: "LoginDialog",

  data: () => ({
    data: {
      username: '',
      password: '',
    },
    error: null,
    onLoginCallback: null,
  }),

  computed:{
    ...mapGetters(["getLogged"])
  },

  watch: {
    getLogged(loggedUser) {
      console.log('loggedUser', loggedUser);
      if (loggedUser && this.onLoginCallback) {
        this.onLoginCallback();
      }
    },
  },

  created() {
    api.interceptors.response.use((response) => response, (error) => {
      // whatever you want to do with the error
      console.log('interceptor error', error.request, error.response);
      if (error.response && error.response.status === 403) {
        this.$store.commit('setLoggedOut');

        console.log('waiting for login...');
        return this.waitForLogin().then(() => {
          console.log('...waiting for login');
          return api.request(error.config);
        });
      }
      throw error;
    });
  },

  methods: {
    login() {
      let _this = this;
      loginApi
          .post('login.php', this.data)
          .then(response => {
            console.log('logged', response.data);
            this.$store.commit('setLoggedIn', response.data);
            _this.error = null;
          })
          .catch(function (error) {
            console.log('login failed', error.response);
            _this.error = error.response.data;
          });
    },
    logOut() {
      loginApi
          .post('login.php?logout', {})
          .then(response => {
            console.log('logged out', response);
            this.$store.commit('setLoggedOut');
          })
          .catch(defaultApiErrorHandler);
    },
    waitForLogin() {
      let _this = this;
      return new Promise((resolve, reject) => {
        if (_this.onLoginCallback) {
          let oldCallback = _this.onLoginCallback;
          _this.onLoginCallback = () => {
            resolve();
            oldCallback();
          };
        } else {
          _this.onLoginCallback = resolve;
        }
      });
    },
  },
}
</script>
